import { render, staticRenderFns } from "./PaidInvoice.vue?vue&type=template&id=1318e1b4&scoped=true&"
import script from "./PaidInvoice.vue?vue&type=script&lang=js&"
export * from "./PaidInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318e1b4",
  null
  
)

export default component.exports